import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-heading3.scss';
import '../font.scss';

const FontHeading3: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY2 : props.color
    };

    return (
        <h3 className={`font font-heading3 ${fontClasses(props)}`}>{props.children}</h3>
    )
};

export default FontHeading3;
